<script setup lang="ts">
import { Translation } from 'vue-i18n';

import { AppConfirmationModal } from '@libs/ui';

import { useCarTripPageStore } from '../stores/carTripPageStore';

const carTripPageStore = useCarTripPageStore();

interface MissedChangePaxModalEmits {
  (event: 'continue'): void;
  (event: 'close'): void;
  (event: 'go-back-and-change'): void;
}
const emit = defineEmits<MissedChangePaxModalEmits>();
</script>

<template>
  <AppConfirmationModal
    :close-button="{ type: 'no-button' }"
    @close="emit('close')"
    @cancel="emit('go-back-and-change')"
    @confirm="emit('continue')"
  >
    <template #headerTitle>{{ $t('modals.missed_change_pax.title') }}</template>
    <template #content>
      <span>{{ $t('modals.missed_change_pax.paragraph_one') }}</span>
      <br />
      <span>
        {{
          $t('modals.missed_change_pax.paragraph_two', [
            carTripPageStore.paxesAmount,
          ])
        }}
      </span>
    </template>
    <template #cancelButton>
      {{ $t('modals.missed_change_pax.go_back_and_change') }}
    </template>
    <template #applyButton>
      <Translation keypath="modals.missed_change_pax.continue" tag="span">
        <template #paxes>
          <span>{{ carTripPageStore.paxesToDisplay }}</span>
        </template>
      </Translation>
    </template>
  </AppConfirmationModal>
</template>
